<template>
    <div>
        <a-card>
            <div class="text-center" style="margin: 40px 0" v-if="ResultInfo.length===0">
                <img style="margin: auto;width: 90px" src="../../img/empty1.png">
                <p class="size2 mt-3 color-ash">采购结果公告未发布</p>
            </div>
            <div class="text-center" style="margin: 40px 0" v-if="ResultInfo.length>0 && pageList.length===0">
                <img style="margin: auto;width: 90px" src="../../img/empty4.png">
                <p class="size2 mt-3 color-ash">无需缴纳成交服务费</p>
            </div>
            <a-row v-if="pageList.length>0">
                <a-col :span="24">
                    <p class="size5 text-center mt-5 mb-2 bold">贵单位在以下包组中成交，请在竞价结果公告发布后的<span
                            class="color-red">三个工作日</span>内缴纳成交服务费！</p>
                    <a-table class="border" ref="table" :data-source="pageList" :rowKey="record => record.id"
                      :pagination="false" :loading="tableLoading">
                      <a-table-column key="serviceIndex" width="15%" title="成交包组" data-index="serviceIndex">
                        <span slot-scope="text,record">包组{{ text }}</span>
                      </a-table-column>
                      <a-table-column key="quotedPrice" width="15%" data-index="quotedPrice">
                        <span slot="title">
                          成交{{ offerType === '2' ? '折扣率' : offerType === '3' ? '下浮率' : '金额' }}
                        </span>
                        <span slot-scope="text,record">
                          <template v-if="record.offerType === '2' || record.offerType === '3'">
                            {{ (text && (text * 100)).toFixed(2) }} %
                          </template>
                          <template v-else>
                            {{ text }} 元
                          </template></span>
                      </a-table-column>
                      <a-table-column key="serviceFee" width="15%" title="成交服务费" data-index="serviceFee">
                        <span slot-scope="text,record">
                          <div v-if="record.isService === '1'">
                            {{ text }}元<span v-if="record.extras.ewjs == '1'" style="color:red">（含税）</span>
                          </div>
                          <div v-else>
                            无需缴纳
                          </div>
                        </span>
                      </a-table-column>
                      <a-table-column key="upFile" width="40%" title="上传凭据">
                        <span slot-scope="text, record">
                          <template v-if="record.isService === '1'">
                            <div class="color-red" v-if="record.isConfirm !== '1'">请扫描上传银行单据，大小不超过1MB</div>
                            <upload-selector ref="UploadSelector" :referId='record.id' :max=1 configKey='supplier_pay_service'
                              :readonly="record.isConfirm === '1'" @uploadSuccess="uploadSelectorChange" />
                          </template>
                          <div v-else>无需上传</div>
                        </span>
                      </a-table-column>
                      <a-table-column key="action" width="15%" title="到账情况">
                        <span slot-scope="text,record">
                          <template v-if="record.isService === '1'">
                            <div>{{ record.isConfirm === '1' ? '已确认到账' : '未确认到账' }}</div>
                          </template>
                          <div v-else>
                            无需确认
                          </div>
                        </span>
                      </a-table-column>
                    </a-table>
                    <p class="size5 text-center mt-5 mb-0 bold">服务费缴纳账号</p>
                    <p class="size5 mt-5 mb-0 bold" style="color:red">服务费缴纳账号以采购文件中注明的为准。</p>
                    <table class="fx-form-view mt-2">
                        <tr>
                            <th>开户银行</th>
                            <td>{{agencyBank.bankName}}</td>
                        </tr>
                        <tr>
                            <th>银行账户</th>
                            <td>{{agencyBank.bankAccountName}}</td>
                        </tr>
                        <tr>
                            <th>银行账号</th>
                            <td>{{agencyBank.bankAccount}}</td>
                        </tr>
                    </table>
                    <p class="size5 text-center mt-5 mb-0 bold">成交通知书</p>
                    <table class="fx-form-view mt-2">
                        <tr>
                            <th>提示</th>
                            <td>
                                <div>代理机构确认成交服务费全部到账后才能开放下载。</div>
                            </td>
                        </tr>
                        <tr>
                            <th>成交通知书</th>
                            <td>
                                <div v-if="isDownLoadFile">
                                    <div v-show="tzsId?true:false">
                                        <upload-selector ref="UploadSelector1" :referId='tzsId' :max=1
                                                         readonly="readonly"
                                                         configKey='CLERK.FILE.PDF'
                                        />
                                    </div>
                                    <div v-show="!tzsId?true:false">
                                        项目经办人暂未发成交通知书，请耐心等待。
                                    </div>
                                    <!--                                    <a-button type="link" @click="downFile">[下载]</a-button>-->
                                </div>
                            </td>
                        </tr>
                    </table>
                </a-col>
            </a-row>
        </a-card>
    </div>
</template>
<script>
  import UploadSelector from '@/components/selector/UploadSelector'
  import qs from 'qs'

  export default {
    components: {
      UploadSelector
    },
    props: {
      projectId: {
        type: String,
        required: true
      },
      random: {
        type: String,
        default: '',
        required: false
      }
    },
    created () {
      // this.initData();
      this.initJjResultInfo()
    },
    watch: {
      random: {
        immediate: false,
        handler (newValue, oldValue) {
          console.log(newValue)
          if (newValue !== oldValue) {
            console.log('has listened data!')
              this.initJjResultInfo()
          }
        }
      }
    },
    name: 'DealServiceInfo',
    data () {
      return {
        pageList: [],
        ResultInfo:[],
        tzsId: '',
        isDownLoadFile: false,
        tableLoading: false,
        agencyBank:'',
        columns: [
          {
            title: '成交包组',
            width: '15%',
            dataIndex: 'serviceIndex',
            scopedSlots: { customRender: 'serviceIndex' }
          },
          {
            title: '成交金额',
            width: '15%',
            dataIndex: 'quotedPrice',
            scopedSlots: { customRender: 'quotedPrice' }
          },
          {
            title: '应交服务费',
            width: '15%',
            dataIndex: 'serviceFee',
            scopedSlots: { customRender: 'serviceFee' }
          },
          {
            title: '上传凭据',
            width: '40%',
            scopedSlots: { customRender: 'upFile' }
          },
          {
            title: '到账情况',
            width: '15%',
            scopedSlots: { customRender: 'action' }
          }
        ],
        offerType: undefined,
      }
    },
    methods: {
      //加载table的数据
      initData () {
        let that = this
        that.tableLoading = true
        that.$http.get('/api/v1/supplier/fee/bidServiceFeeList.json?projectId=' + that.projectId).then(function (response) {
          that.tableLoading = false
          if (response.code != 200) {
            return
          }
          that.pageList = response.result.bidServiceFeeVos
          that.isDownLoadFile = response.result.isDownLoadFile
            that.agencyBank = response.result.agencyBank
          that.tzsId = response.result.tzsId
          that.offerType = response.result.offerType
        })
      },
      initJjResultInfo () {
        let that = this
        this.$http.get('/api/v1/supplier/fee/getJjJgAnnounceList.json?projectId=' + that.projectId).then(function (res) {
          if (res.code != 200) {
            return
          }
          that.ResultInfo = res.result
          //console.log(res.result)
          if (res.result.length>0) {
            that.initData()
          }
        })
      },
       //supplierName
        uploadSelectorChange(fileLength){
                let that=this;
                if(fileLength){
                    const user = this.$ls.get('user');
                    let projectName=this.ResultInfo[0].projectName;
                    if(projectName&&user.supplierName){
                        let title="项目消息";
                        let content=user.supplierName+"已上传了"+projectName+"的成交服务费缴纳凭据，请及时确认到账情况。";
                        this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id='+this.projectId+'&title='+title+'&content='+content).then(function (res) {

                        })
                    }
                }
        }
    }
  }
</script>

<style scoped>
    .fx-form-view {
        table-layout: auto;
    }

    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f9f9f9;
    }

    .fx-form-view td {
        border: 1px solid #e6e6e6;
    }
</style>
